import { createFileRoute, redirect } from "@tanstack/react-router";
import StateLevelDataViewPage from "@/pages/StateLevelDataViewPage";
import { isAdminBuild } from "@/utils/isAdminBuild";

export const Route = createFileRoute(
  "/$leaid/_error-wrapper/admin/state-level-data-view"
)({
  beforeLoad: ({ context, params }) => {
    if (
      !isAdminBuild() ||
      params.leaid !== "0-" ||
      !context.hasRole("ADMIN")
    ) {
      throw redirect({ to: "/$leaid", params: { leaid: params.leaid } });
    }
  },
  component: StateLevelDataViewPage,
});
